import Environment from '../environment/Environment';
import { ObjToQueryString } from '../helpers/Helpers';

import { IMeasureVisibilityPayload, IWeightMeasurePayload } from '../interfaces/common.interface';
import { IColWidthPayload } from '../interfaces/common.interface';
import { getRequest, HandlerResponse, postRequest } from './api';
import { genearteNewToken } from './NewToken.api';

export const UpdateMeasureVisibility = async (payload: IMeasureVisibilityPayload, queryParams?: any) => {
  genearteNewToken();
  const queryString = ObjToQueryString(queryParams);
  return postRequest(`${Environment.API}/home/saveMeasureVisibility${queryString}`, payload)
    .then((resp: any) => HandlerResponse(resp));
};

export const DownloadTemplate = async (queryParams?: any) => {
  genearteNewToken();
  const queryString = ObjToQueryString(queryParams);
  return getRequest(`${Environment.API}/excel/download${queryString}`)
    .then((resp: any) => resp);
};

export const DownloadSKULevelEditAllTemplate = async (queryParams?: any) => {
  genearteNewToken();
  const queryString = ObjToQueryString(queryParams);
  return getRequest(`${Environment.API}/excel/SKUEditAll/download${queryString}`)
    .then((resp: any) => resp);
};

export const DownloadEditAllTemplate = async (queryParams?: any) => {
  genearteNewToken();
  const queryString = ObjToQueryString(queryParams);
  return getRequest(`${Environment.API}/excel/editAll/download${queryString}`)
    .then((resp: any) => resp);
};

export const DownloadSkuVsFrozenSalesTemplate = async (queryParams?: any) => {
  genearteNewToken();
  const queryString = ObjToQueryString(queryParams);
  return getRequest(`${Environment.API}/excel/skuVsFrozenSales/download${queryString}`)
    .then((resp: any) => resp);
};

export const DownloadSkuLevelTemplate = async (queryParams?: any) => {
  genearteNewToken();
  const queryString = ObjToQueryString(queryParams);
  return getRequest(`${Environment.API}/excel/skuLevelSalesPlan/download${queryString}`)
    .then((resp: any) => resp);
};

export const UpdateColWidth = async (payload: IColWidthPayload, queryParams?: any) => {
  genearteNewToken();
  const queryString = ObjToQueryString(queryParams);
  return postRequest(`${Environment.API}/home/saveMeasureWidth${queryString}`, payload)
    .then((resp: any) => HandlerResponse(resp));
};

export const UpdateColSequence = async (payload, queryParams?: any) => {
  genearteNewToken();
  const queryString = ObjToQueryString(queryParams);
  return postRequest(`${Environment.API}/home/saveMeasureSeq${queryString}`, payload)
    .then((resp: any) => HandlerResponse(resp));
};

export const GetLastActivity = async () => {
  genearteNewToken();
  return getRequest(`${Environment.API}/dashboard/lastActivity`)
    .then((resp: any) => HandlerResponse(resp));
};

export const UpdateWeightMeasure = async (payload: IWeightMeasurePayload) => {
  genearteNewToken();
  return postRequest(`${Environment.API}/sku/updateWeightMeasure`, payload)
    .then((resp: any) => HandlerResponse(resp));
};

export const DownloadUsageReportData = async (queryParams?: any) => {
  genearteNewToken();
  const queryString = ObjToQueryString(queryParams);
  return getRequest(`${Environment.API}/dashboard/downloadUsageExcel${queryString}`)
  .then((resp: any) => resp);
};


export const HelpContent = async (queryParams?: any) => {
  genearteNewToken();
  const queryString = ObjToQueryString(queryParams);
  return getRequest(`${Environment.API}/api/help/docs${queryString}`)
  .then((resp: any) => resp);
};
